/**
 * 推荐房源
 */
import React, { Component } from "react";
import Slider from "@components/x-slider";
import { processProduct } from "@views/product-list/helpers/product";
import Product from "@views/product-list/components/product";

class Recommends extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
    };
  }
  render() {
    const { products } = this.state;
    if (products.length > 0) {
      const slides = products.map((item, index) => ({
        src: (
          <div className="recommends-grid__item" key={item.productId} data-index={index}>
            <Product product={processProduct(item)} showFavButton={false} />
          </div>
        ),
      }));
      return (
        <div className="recommends-grid">
          <Slider
            slides={[...slides.slice(0, slides.length - 1)]}
            displayProgress={false}
            onRenderSlide={function(slide, isCurrent, k) {
              return [slide.src, slides[k + 1].src];
            }}
          />
        </div>
      );
    }
    return <noscript />;
  }
}

export default Recommends;
